// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--YNnA5";
export var btnBlock = "banner-module--btnBlock--WTh8G";
export var container = "banner-module--container--EitNE";
export var hideMobBlock = "banner-module--hideMobBlock--8VAih";
export var img = "banner-module--img--Vsotl";
export var imgDebetCard = "banner-module--imgDebetCard--jYh+9";
export var imgHalva = "banner-module--imgHalva--A16YU";
export var imgWrapper = "banner-module--imgWrapper--zOXIV";
export var mobBtn = "banner-module--mobBtn--C9LgG";
export var secondContainer = "banner-module--secondContainer--KDtbM";
export var section = "banner-module--section--DMPd6";
export var textBlock = "banner-module--textBlock--0b3m5";